import { useState } from 'react';
import File from './File';

export default function FileExplorer({ files, callback, multiple, s=[], selectFolder=false}) {
    const [selected, setSelected] = useState(s);

    const toggle = multiple ? (dir, file) => {
        let out = [...selected];
        let isSelected = selected.findIndex(v=>v===dir+(typeof file === 'string' ? file : "")) !== -1;
        let toToggle = [findRecursive(file, dir)].flat();

        if (isSelected) {
            toToggle.forEach(file => {
                let idx = out.findIndex(v=>v===file);
                if (idx!==-1) out.splice(idx, 1);
            });
        }
        else {
            toToggle.forEach(file => {
                let idx = out.findIndex(v=>v===file);
                if (idx===-1) out.push(file);
            });
        }

        setSelected(out);
        callback(out);
    } : (dir, file) => {
        setSelected(dir+(selectFolder ? "" : file));
        callback(dir+(selectFolder ? "" : file));
    }

    function findRecursive(file, path="") {
        return file.children ? [path, ...file.children.map(f => findRecursive(f, f.name?f.name+"/":"").map(e=>path+e)).flat()] :[ path+file];
    }

    function expand(dir,path="") {
        if (!dir || !dir.children) return;
        return (
            <li key={dir.name}>
                {multiple && <input type="checkbox" checked={Array.isArray(selected) ? selected.includes(path) : selected === path} onChange={()=>toggle(path, dir)} />}
                {selectFolder && <input type="checkbox" checked={Array.isArray(selected) ? selected.includes(path) : selected === path} onChange={()=>toggle(path, dir)} />}
                <span className='folder' onClick={e=>{e.target.parentElement.querySelector(".nested").classList.toggle("active"); e.target.classList.toggle("folder-down");}}>{dir.name}</span>

                <ul className='nested'>
                    {dir.children.map(child=>{
                        if (typeof child === "string")
                            return <File key={child} selected={selected.includes(path+child)} callback={()=>{toggle(path, child)}} multiple={multiple} enabled={!selectFolder}>{child}</File>;
                        return expand(child, path+child.name+"/")
                    })}
                </ul>
            </li>
        )
    }

    return (
        <ul id="fileExplorer" className="fileExplorer">
            {expand(files)}
        </ul>
    )
}